export default __webpack_public_path__ + "static/media/cranberry.fca3b744.jpg";